import React, { createContext, useContext, useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Orgs from './pages/Orgs';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

const PrivateRoute = ({ children }) => {
  const { token } = useAuth();
  return token ? children : <Navigate to="/login" replace />;
};

export default function App() {
  const [token, setToken] = useState(localStorage.getItem('helm_token'));
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('helm_user')); } catch { return null; }
  });

  const login = (t, u) => {
    localStorage.setItem('helm_token', t);
    localStorage.setItem('helm_user', JSON.stringify(u));
    setToken(t);
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem('helm_token');
    localStorage.removeItem('helm_user');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ token, user, login, logout }}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/orgs" element={<PrivateRoute><Orgs /></PrivateRoute>} />
          <Route path="/" element={<Navigate to="/orgs" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthContext.Provider>
  );
}
